import {
  MRT_GlobalFilterTextField,
  MaterialReactTable,
  type MRT_ColumnDef,
  useMaterialReactTable,
} from 'material-react-table';
import { Box, Button, lighten } from '@mui/material';
import CurrencyFormat from '@/utils/CurrencyFormat';

interface VarData {
  year: number;
  value: number;
}

interface TableData {
  id: number;
  serie_name: string;
  updated_value: number;
  index_value: number;
  vars: VarData[];
}

const createColumns = (data: TableData[]): MRT_ColumnDef<TableData>[] => {
  const uniqueYears = Array.from(new Set(data.flatMap((item) => item.vars.map((v) => v.year))));

  const yearColumns = uniqueYears.map((year) => ({
    accessorFn: (row: TableData) => {
      const yearData = row.vars.find((v) => v.year === year);
      return yearData ? yearData.value : null;
    },
    id: `VAR${year}`,
    header: `VAR R$ ${year}`,
    size: 150,
    Cell: ({ renderedCellValue }) => <Box>{CurrencyFormat.formatWithDecimais(Number(renderedCellValue) || 0)}</Box>,
  }));

  const firstColum: MRT_ColumnDef<TableData>[] = [
    {
      accessorKey: 'serie_name',
      header: 'Faixa de ensino',
      size: 150,
    },
  ];

  const fixedColumns: MRT_ColumnDef<TableData>[] = [
    {
      accessorKey: 'updated_value',
      header: 'Valor Atualizado',
      size: 150,
      Cell: ({ renderedCellValue }) => <Box>{CurrencyFormat.formatWithDecimais(Number(renderedCellValue))}</Box>,
    },
    {
      accessorKey: 'index_value',
      header: 'Índice de valor',
      size: 100,
      Cell: ({ renderedCellValue }) => <div>{renderedCellValue} %</div>,
    },
  ];

  return [...firstColum, ...yearColumns, ...fixedColumns];
};

const TableIndixeConfigAvancadas = ({ data }) => {
  const columns = createColumns(data);

  const tableBasic = useMaterialReactTable({
    columns,
    data,
    positionActionsColumn: 'last',
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableGrouping: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableExpandAll: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enableRowSelection: true,
    enableBottomToolbar: true, // Habilitar a barra de ferramentas inferior
    initialState: {
      showGlobalFilter: true,
    },
    paginationDisplayMode: 'pages', // Certifique-se de que a paginação está habilitada
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [10, 20, 30], // Opções de quantidade de linhas por página
      shape: 'rounded',
      variant: 'outlined',
    },
    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        backgroundColor: '#F7F7F7',
        color: 'black',
        fontWeight: 400,
        fontSize: '12px',
      },
    }),
    muiTableBodyCellProps: ({ column }) => ({
      sx: {
        backgroundColor: '#fff',
        color: 'rgba(128, 128, 128, 1)',
        fontWeight: 400,
        fontSize: '12px',
      },
    }),
    localization: {
      rowsPerPage: 'Quantidade de linhas por Página', // Personaliza o texto
    },
  });

  return (
    <>
      <MaterialReactTable table={tableBasic} />
    </>
  );
};

export default TableIndixeConfigAvancadas;
